import { render } from "./ReleaseNote.vue?vue&type=template&id=2ab0e193"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\js\\bible_finder_ui_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__